import { Fragment } from "react";

/**
 * Render a backend-generated search snippet without dangerouslySetInnerHTML.
 * The backend (`routers/search.py`) wraps every matched token in `<mark>...</mark>`
 * — no other tags are ever produced — so we parse just that one element and
 * render the rest as plain text. This eliminates the XSS vector entirely
 * (any attacker-controlled `<script>` etc. in indexed data would render as
 * literal text).
 */
const MARK_RE = /<mark>([\s\S]*?)<\/mark>/g;

export default function SafeSnippet({ snippet, className }) {
  if (!snippet) return null;
  const parts = [];
  let lastIndex = 0;
  let m;
  MARK_RE.lastIndex = 0;
  while ((m = MARK_RE.exec(snippet)) !== null) {
    if (m.index > lastIndex) {
      parts.push({ type: "text", value: snippet.slice(lastIndex, m.index) });
    }
    parts.push({ type: "mark", value: m[1] });
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < snippet.length) {
    parts.push({ type: "text", value: snippet.slice(lastIndex) });
  }
  return (
    <span className={className}>
      {parts.map((p, i) => (
        // Stable key from part content + position (text and mark segments are
        // determined by regex match boundaries so this is deterministic per snippet).
        <Fragment key={`${p.type}-${i}-${p.value.slice(0, 8)}`}>
          {p.type === "mark" ? <mark className="bg-yellow-200 text-zinc-950 px-0.5">{p.value}</mark> : p.value}
        </Fragment>
      ))}
    </span>
  );
}
